var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"scrollbar",rawName:"v-scrollbar.y",modifiers:{"y":true}}],staticClass:"c-static-page"},[_c('rich-text-content',{attrs:{"content":_vm.module.config.content}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }